import React from 'react';

import { Icon, IconProps } from '../base-icon';

export const H4Icon = (props: IconProps) => (
  <Icon name='h4 icon' viewBox='0 0 628 578' {...props}>
    <path
      d='M605.457 364.719V494.65h21.68v38.086h-21.68V578h-49.365v-45.264H473.62l-2.93-30.175 85.4-137.403v-.44h49.366zm-49.365 64.306l-3.077 4.98-35.302 60.645h38.379v-65.625zM176 0c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-32v128h192V64h-32c-8.837 0-16-7.163-16-16V16c0-8.837 7.163-16 16-16h160c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-32v320h32c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H304c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h32V256H144v128h32c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h32V64H16C7.163 64 0 56.837 0 48V16C0 7.163 7.163 0 16 0h160z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </Icon>
);
